import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-timeline-standalone',
  templateUrl: './timeline-standalone.component.html',
  styleUrls: ['./timeline-standalone.component.scss']
})
export class TimelineStandaloneComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
